import { Image, Link } from '@chakra-ui/react'
import React from 'react'

const ElksLodge: React.FC = () => (
  <Image
    src='/ElksLodge2025-04-26.png'
    alt='Join us at the Lodge for a Block Party
      Elks Lodge (7704 Dixie Highway) on Saturday, April 26th between
      12:00 PM - 8:00 PM with Live Music, Games and Food!'
  />
)
export default ElksLodge
